<div class="modal-header">
  <h5 class="modal-title">Task Information</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Close"></button>
</div>
@if (task) {
  <div class="modal-body">
    <div class="row text-end">
      <a href="javascript: void(0);" (click)="toggleTaskView()">Show Task {{historyVisible ? "Details" : "History"}}</a><hr>
    </div>
    @if (!historyVisible) {
      <div>
        <form #conditonsTaskForm="ngForm" novalidate id="conditonsTaskForm" name="conditonsTaskForm">
          <div class="row">
            <div class="col-md-7">
              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-3 row">
                    <label class="col-sm-2 form-label align-self-center mb-lg-0 text-end">Description</label>
                    <div class="col-sm-10">
                      <input class="form-control" placeholder="Description" id="escalationDescription"
                        name="escDescription" type="text" [(ngModel)]="task.description" [disabled]="true">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group mb-3 row">
                      <label for="notes" class="col-sm-2 form-label mb-lg-0 text-end">Notes</label>
                      <div class="col-sm-10">
                        <textarea class="form-control" placeholder="Add a note" id="notes" name="note"
                        [(ngModel)]="task.note" type="text" rows="4"></textarea>
                        @if (listInternalNotes && listInternalNotes.length > 0) {
                          <ul>
                            @for (note of listInternalNotes; track note) {
                              <li>
                                <span class="note-pre-wrap">{{note.content}}</span>
                                <div>{{note.senderFirstName}} {{note.senderLastName}}
                                ({{note.postTime | date:'MMM d, y h:mm:ss a'}})</div>
                              </li>
                            }
                          </ul>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group mb-3 row">
                      <label class="col-sm-2 form-label mb-lg-0 text-end">Request Date</label>
                      <div class="col-sm-4">
                        <input id="RequestDate" class="form-control" placeholder="Request Date"
                          name="RequestDate" type="text" value="{{task.requestDate | date:'MM/dd/yyyy h:mma'}}"
                          [disabled]="true">
                        </div>
                        <label class="col-md-2 form-label mb-lg-0 text-end">Due Days</label>
                        <div class="col-md-4">
                          <input class="form-control" placeholder="Due Days" name="dueDays" type="text"
                            [(ngModel)]="task.dueDays" [disabled]="true">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group mb-3 row">
                          <label class="col-md-2 form-label mb-lg-0 text-end">Responsible Party</label>
                          <div class="col-md-4">
                            <select class="form-control " id="responsibleUser" [(ngModel)]="task.userId" name="responsibleUser" [disabled]="true">
                              <option value="">-- Select One --</option>
                              @for (user of users; track user) {
                                <option value="{{user.userCompanyGuid}}"
                                  [selected]="user.userCompanyGuid == task.userId">
                                  {{user.lastName + ", " + user.firstName}}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group mb-3 row">
                          <label class="col-md-2 form-label mb-lg-0 text-end">Condition</label>
                          <div class="col-md-1">
                            <input class="form-check-input" type="checkbox" id="condition" name="condition"
                              [(ngModel)]="task.condition" [checked]="task.condition" [disabled]="true">
                            </div>
                            @if (task.condition) {
                              <label class="col-md-1 form-label mb-lg-0 text-end">Id</label>
                            }
                            @if (task.condition) {
                              <div class="col-md-2">
                                                                <input class="form-control" type="text" id="conditionId" [(ngModel)]="task.conditionId"
                                                                  [disabled]="true">
                                </div>
                              }
                              @if (task.condition) {
                                <label class="col-md-2 form-label mb-lg-0 text-end">Type</label>
                              }
                              @if (task.condition) {
                                <div class="col-md-4">
                                  <select class="form-control" [(ngModel)]="task.conditionType" [disabled]="true">
                                    <option value="">-- Select One --</option>
                                    <option value="Approval">Approval</option>
                                    <option value="Docs">Docs</option>
                                    <option value="Funding">Funding</option>
                                    <option value="Closing">Closing</option>
                                    <option value="Purchase">Purchase</option>
                                  </select>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        @if (task.condition) {
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label class="col-md-2 form-label mb-lg-0 text-end">Condition Text</label>
                                <div class="col-md-10">
                                  <textarea class="form-control" placeholder="Exact condition text" name="conditionText"
                                  [(ngModel)]="task.conditionText" [disabled]="true"></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group mb-3 row">
                              <label class="col-md-2 form-label mb-lg-0 text-end">Request From Borrower</label>
                              <div class="col-md-10">
                                <input class="form-check-input" type="checkbox" id="requestBorrower" name='requestBorrower'
                                  [(ngModel)]="task.requestBorrower" [checked]="task.requestBorrower">
                                </div>
                              </div>
                            </div>
                          </div>
                          @if (task.requestBorrower || (listBorrowerNotes && listBorrowerNotes.length > 0)) {
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group mb-3 row">
                                  <label for="borrowerFacingNote" class="col-sm-2 form-label mb-lg-0 text-end">Borrower Facing Note</label>
                                  <div class="col-sm-10">
                                    @if (task.requestBorrower) {
                                      <textarea class="form-control" placeholder="Add a borrower facing note" id="borrowerFacingNote"
                                      name="borrowerFacingNote" [(ngModel)]="task.borrowerFacingNote" type="text" rows="4"></textarea>
                                    }
                                    @if (listBorrowerNotes && listBorrowerNotes.length > 0) {
                                      <ul>
                                        @for (note of listBorrowerNotes; track note) {
                                          <li>
                                            <span class="note-pre-wrap">{{note.content}}</span>
                                            <div>{{note.senderFirstName}} {{note.senderLastName}}
                                            ({{note.postTime | date:'MMM d, y h:mm:ss a'}})</div>
                                          </li>
                                        }
                                      </ul>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="col-md-5">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group mb-3 row">
                                <label for="files" class="col-sm-2 form-label mb-lg-0 text-end">Upload/View</label>
                                <div class="col-sm-10">
                                  <file-upload
                                    [(ngModel)]="uploadedFiles"
                                    multiple="true"
                                    name="files"
                                    (ngModelChange)="onFileUploadChanged($event)">
                                  </file-upload>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                }
                @if (historyVisible) {
                  <div>
                    @if (taskTrackingInfo) {
                      <p-table #dt [value]="taskTrackingInfo" [paginator]="true" [rows]="25"
                        [rowsPerPageOptions]="[10,25,50]" [globalFilterFields]="['actionValue','dateCreated','firstName','lastName','userName']"
                        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        styleClass="p-datatable-gridlines">
                        <ng-template pTemplate="caption">
                          <div class="p-d-flex">
                            <p-iconfield class="p-ml-auto">
                              <input pInputText #searchText type="text" class="form-control" (ngModelChange)="dt.first=0"
                                (input)="dt.filterGlobal(searchText.value, 'contains')" placeholder="Search keyword" />
                                <p-inputicon styleClass="pi pi-search" />
                              </p-iconfield>
                            </div>
                          </ng-template>
                          <ng-template pTemplate="header">
                            <tr>
                              @for (col of columns; track col) {
                                <th [pSortableColumn]="'dateCreated'">
                                  {{col.header}}
                                </th>
                              }
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-taskTrackingInfo>
                            <tr>
                              <td> {{taskTrackingInfo.actionValue}} </td>
                              <td> {{taskTrackingInfo.dateCreated | date: 'MM/dd/yyyy h:mma'}} </td>
                              <td>
                                @if (taskTrackingInfo.by!=null && (taskTrackingInfo.userProfile.firstName != null || taskTrackingInfo.userProfile.lastName != null)) {
                                  <span>
                                    {{taskTrackingInfo.userProfile.firstName}} {{taskTrackingInfo.userProfile.lastName}}
                                  </span>
                                }
                                @if (taskTrackingInfo.by!=null && taskTrackingInfo.userProfile.firstName == null && taskTrackingInfo.userProfile.lastName == null) {
                                  <span>
                                    {{taskTrackingInfo.userProfile.userName}}
                                  </span>
                                }
                                @if (taskTrackingInfo.borrowerId!=null) {
                                  <span>
                                    {{taskTrackingInfo.borrower.firstName}} {{taskTrackingInfo.borrower.lastName}}
                                  </span>
                                }
                              </td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="3" class="text-center"> No history found. </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      }
                    </div>
                  }
                </div>
              }
              <div class="modal-footer form-footer">
                <button type="button" class="btn btn-secondary right" (click)="onCancelClicked()">Cancel</button>
                <button type="button" class="btn btn-primary right" (click)="onOkClicked()">Ok</button>
              </div>
